(() => {
  if (customElements.get('cart-remove-button')) {
    return;
  }

  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
    }


    handleRemove(event) {
      event.preventDefault();

      const parentEl = this.closest('[data-cart-items]');
      if (parentEl) {
        [...parentEl.querySelectorAll('.cart-item__grid')].forEach((cartItem) => {
          cartItem.classList.add('opacity-50', 'pointer-events-none');
        });
      }

      if (this.getAttribute('data-group-id')) {
        const groupId = this.getAttribute('data-group-id');
        const config = fetchConfigDefaults("application/javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        
        fetch(`${theme.routes.cart_url}`, config)
          .then(res => res.json())
          .then(data => {
            const groupIdItems = data.items.filter((item) => {
              return item.properties['_group_id'] === groupId;
            });
            const formData = new FormData();
            groupIdItems.forEach((item) => {
              formData.append(`updates[${item.key}]`, 0);
            });

            this.removeItem(`${theme.routes.cart_update_url}`, formData)
              .then((response) => {
                document.dispatchEvent(
                  new CustomEvent('theme:update:cart', {
                    bubbles: true,
                  })
                );
              })
          })
        return;
      }

      this.removeItem()
        .then((response) => {
          document.dispatchEvent(
            new CustomEvent('theme:update:cart', {
              bubbles: true,
            })
          );
        });
    }

    removeItem(urlParam, formDataParam) { 
      return new Promise((resolve, reject) => {
        const url = urlParam ? urlParam: this.querySelector('a').href;
        const config = fetchConfigDefaults("application/javascript");
        const formData = formDataParam ? formDataParam: new FormData();
        formData.append("sections", "cart-items,cart-footer,cart-item-count,cart-live-region");
        formData.append("sections_url", window.location.pathname);
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = formData;
        fetch(url, config)
          .then(res => res.json())
          .then(data => {
            if (data.status) {
              console.error(data.status);
              return reject(data.status);
            }
            return resolve(data);
          })
      })
    }

    removeGroupProducts(excludedButton) {
      const parentEl = this.closest('[data-cart-items]');
      if (!parentEl) {
        console.error('No parent el')
        return;
      }
      const groupIdRemoveButtons = parentEl.querySelectorAll(`cart-remove-button[data-group-id="${this.getAttribute('data-group-id')}"]`);

      if (groupIdRemoveButtons.length === 0) {
        console.error('No remove buttons')
        return;
      }

      const removePromises = [...groupIdRemoveButtons].map((button) => {
        if (button !== excludedButton) {
          return button.removeItem();
        }
      });
      Promise.all(removePromises)
        .then(() => {
          document.dispatchEvent(
            new CustomEvent('theme:update:cart', {
              bubbles: true,
            })
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }

    connectedCallback() {
      this.querySelector('a').addEventListener('click', this.handleRemove.bind(this));
    }
  }

  customElements.define('cart-remove-button', CartRemoveButton);
})();
